import React, { useEffect } from "react";
import { useDetectVesselConnection } from "../../../hooks/useDetectVesselConnection";
import Grid from "@mui/material/Grid2";
import { useSepTrendData } from "../../../hooks/useSepTrendData";
import { useDurationHandle } from "../calendarDuration/useDurationHandle";
import { DURATION } from "../calendarDuration/durationOption";
import { EngineTrendBase } from "../engine/engineTrendBase.jsx";
import { SEP_CHART_TYPE } from "../../../constants/trendGraph/sepLines";
import PropTypes from "prop-types";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";

export const Sep = (props) => {
  const {
    vesselId,
    currentVessel,
    selectedChart,
    graphData,
    setGraphData,
    setDataFetchStatus,
    trendCharts,
    isVesselOverview,
    setChartRef,
  } = props;

  const { connections } = useDetectVesselConnection();
  const isDisconnected = connections.includes(vesselId);

  const { sepValues, isLoading, isNoData } = useSepTrendData(vesselId);

  useEffect(() => {
    setDataFetchStatus({
      isLoading,
      isNoData,
    });
  }, [isLoading, isNoData]);

  useDurationHandle(DURATION.SEP, null);

  return (
      <Grid container spacing={2}>
        <Grid item size={{xs: 12}}>
          <EngineTrendBase
            values={sepValues}
            isDurationDisabled={isLoading}
            isNoData={isNoData}
            isLoading={isLoading}
            isDisconnected={isDisconnected}
            vesselId={vesselId}
            vessel={currentVessel}
            chartList={SEP_CHART_TYPE}
            graphType={GRAPH_TYPE.SEP}
            selectedChart={selectedChart}
            graphData={graphData}
            setGraphData={setGraphData}
            customLineData={trendCharts?.[selectedChart]}
            isVesselOverview={isVesselOverview}
            setChartRef={setChartRef}
          />
        </Grid>
      </Grid>
  );
};

Sep.propTypes = {
  vesselId: PropTypes.string,
  selectedChart: PropTypes.string,
  isVesselOverview: PropTypes.bool,
  setChartRef: PropTypes.func,
  currentVessel: PropTypes.object,
  graphData: PropTypes.array,
  setGraphData: PropTypes.func,
  setDataFetchStatus: PropTypes.func,
  trendCharts: PropTypes.array,
};